"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlBuilder = void 0;
__exportStar(require("./types"), exports);
class UrlBuilder {
    constructor(urls) {
        this.urls = {};
        this.urls = urls || {};
    }
    getRegexp(key) {
        return new RegExp(`{${key}}`);
    }
    hasRegexp(url) {
        return /{.*}/.test(url);
    }
    checkRegexp(url) {
        if (this.hasRegexp(url)) {
            throw new Error('params error');
        }
    }
    parseUrl(url, params) {
        if (!params) {
            this.checkRegexp(url);
            return url;
        }
        const result = Object.keys(params).reduce((pv, cv) => {
            const regexp = this.getRegexp(cv);
            return pv.replace(regexp, params[cv]);
        }, url);
        this.checkRegexp(result);
        return result;
    }
    setUrls(urls) {
        this.urls = urls;
    }
    getUrl(key, params) {
        const url = this.urls[key];
        if (!url)
            throw new Error(`Key ${key} doesn't defined`);
        return this.parseUrl(url, params);
    }
}
exports.UrlBuilder = UrlBuilder;
//# sourceMappingURL=index.js.map